import { QUOTE_FRAGMENT } from 'customer-flows/gql/fragments/quote'
import { useMutation } from 'glimmer-apollo'
import { parse, print } from 'graphql'

export function applyTipToQuote(
  context: Object,
  variables: ApplyTipToQuoteInput
): Promise<ApplyTipToQuoteResponse | undefined | null> {
  return new Promise((resolve, reject) => {
    const applyTipToQuoteMutation = useMutation<ApplyTipToQuoteResponse, { input: ApplyTipToQuoteInput }>(context, () => [
      mutation,
      {
        onError: (error) => {
          reject(new Error('Failed to apply redemption code.', { cause: error }))
        },
        onComplete: (data: ApplyTipToQuoteResponse | undefined | null) => {
          resolve(data)
        }
      }
    ])

    applyTipToQuoteMutation.mutate({
      input: variables
    })
  })
}

const mutation = parse(`
  mutation ApplyTipToQuote($input: ApplyTipToQuoteInput!) {
    applyTipToQuote(input: $input) {
      ... on ApplyTipToQuoteSuccess {
        quote {
          ...QuoteFragment
        }
      }
      ... on NotFoundError {
        id
        message
      }
    }
  }
  ${print(QUOTE_FRAGMENT)}
`)
